import * as React from 'react'
import {Link} from 'react-router-dom'
import { connect } from 'react-redux'
import {Button, TYPES} from './../components/shared/button'
import { fetchSingleUnverifiedVisit } from  './../redux/actions/verification'
import VideoPlayer from './../components/video/videoPlayer'
import VerificationInput from './../components/verification/verificationInput'
import './../styles/video/video.css'
import Page from './../components/shared/page'
import arrow from './../images/left-arrow-circle.png'
import warning from './../images/warning.png'
import Modal from './../components/shared/modal'

var strftime = require('strftime')

class VerificationVideo extends React.Component {

  constructor() {
    super()

    this.state = {
      showModal: false
    }
  }

  componentDidMount() {
    const id = Number(this.props.match.params.id)
    this.props.fetchSingleUnverifiedVisit(id)
  }

  componentDidUpdate(prevProps) {
    if(prevProps.match.params.id !== this.props.match.params.id) {
      window.location.reload()
    }
  }

  toggleModal = () => {
    this.setState({ showModal: !this.state.showModal })
  }

  licensePlateCheck = (num) => {
    if(num === null) {
      return 'No Plate Read'
    } else {
      return num
    }
  }

  outputUnsupportedBrowserWarning = () => {
    const isFirefox = typeof InstallTrigger !== 'undefined'
    const isChrome = !!window.chrome && (
      !!window.chrome.webstore
      || navigator.vendor.toLowerCase().indexOf('google inc.') !== -1
    )
    if(!isChrome && !isFirefox) {
      return (
        <div className='video-archived'>
          <img src={warning} alt='warning symbol'/>
          <div>
            <h4>This page is optimized for Chrome and Firefox</h4>
            <p className='browser-check'>
              <a href='mailto: tanner@baywatchtech.com'>Contact support</a> with any issues
            </p>
          </div>
        </div>
      )
    }
  }

  render () {
    const visit = this.props.verification.sinlgeUnverifiedVisit
    return (
      <Page history={this.props.history}>
        <div className='video-inner-container'>
          <div className='video-top'>
            {visit &&
              <Link to={`/verification`}>
                <div className='video-back-button'>
                  <img src={arrow} alt='Back'/>
                  <p>Back to angle selection</p>
                </div>
              </Link>
            }
            <div className='video-warning-box'>
              {this.outputUnsupportedBrowserWarning()}
            </div>
            <div className='review-license-plate'>
              <p id='review-license-plate'>
                <b>License:</b>
                {visit && ' ' + this.licensePlateCheck(visit.license_plate)}
              </p>
              <p>
                <b>Date:</b>
                {visit && ' ' + strftime('%D %I:%M %p', new Date(visit.triggered_at))}
              </p>
              <p>
                <b>Bay:</b>
                {visit && ' ' + visit.bay}
              </p>
              <p>
                <b>Angle:</b>
                {visit && ' ' + visit.recordings[0].angle_name}
              </p>
            </div>
          </div>
          <div className='video-bottom'>
            {visit &&
              <div className='available-angle-control-panel'>
                <VerificationInput history={this.props.history}/>
              </div>}
            <div className='video-player'>
              {visit &&
                <VideoPlayer videoURL={visit.recordings[0].video_url} recording_id={this.props.match.params.id} hiddenScreen={null} history={this.props.history} key={"videoPlayer" + this.props.match.params.id} hideSpinner={this.hideSpinner} needs_verification={true} passenger_middle={visit.recordings[6].video_url}/>
              }
            </div>
          </div>
        </div>
        {this.state.showModal &&
          <Modal onCloseRequest={() => this.toggleModal()}>
              <div className='restore-archived-video-form-container'>
                <h3>Restore Video</h3>
                <form onSubmit={this.onRestoreSubmit} className='restore-archived-video-form'>
                  <label for='days'>Days:</label>
                  <select onChange={(event) => this.setState({daysToRestoreVideo: event.target.value})} id='days'>
                    <option>7</option>
                    <option>10</option>
                    <option>15</option>
                    <option>20</option>
                    <option>25</option>
                    <option>30</option>
                    <option>35</option>
                    <option>40</option>
                    <option>45</option>
                    <option>50</option>
                    <option>55</option>
                    <option>60</option>
                  </select>
                  <label for='tier'>Tier:</label>
                  <select onChange={(event) => this.setState({tier: event.target.value})} id='tier'>
                    <option value='Standard'>Standard</option>
                    <option value='Expedited'>Expedited</option>
                    <option value='Bulk'>Bulk</option>
                  </select>
                  <Button
                    text='Restore'
                    buttonType={TYPES.SUBMIT}
                  />
                </form>
              </div>
          </Modal>
        }
      </Page>
    )
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch)=> {
  return {
    fetchSingleUnverifiedVisit: (id) => {
      return dispatch(fetchSingleUnverifiedVisit(id));
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(VerificationVideo)



// WEBPACK FOOTER //
// ./src/pages/verificationVideo.js